import $ from "jquery";

export function showContactFormOnLoad() {
    $(document).ready(function () {
        $("#contactForm").show();
    });
}
